import React, { useEffect } from "react";
import AppConfig from "../entities/AppConfig";
import { useLocalStorage } from "../utilities/useLocalStorage";
import { AppConfigContext, defaultAppConfig } from "../utilities/useAppConfig";
import { AppConfigService } from "../services/AppConfigService";
import { useOfflineStatus } from "../utilities/useOfflineStatus";
import { StripeProvider } from "react-stripe-elements";
import { LoadingPage } from "./LoadingPage";
import { PageTitleContext } from "../utilities/usePageTitle";

interface AppConfigProviderProps {
}

export function AppConfigProvider(props: React.PropsWithChildren<AppConfigProviderProps>){
    const isOffline = useOfflineStatus();
    const [appConfig, setAppConfig] = useLocalStorage<AppConfig>("offlineAppConfig", defaultAppConfig);
    const [stripe, setStripe] = React.useState<stripe.Stripe | null>(null);
	const [title, setTitle] = React.useState("Sermon Maker");

    useEffect(() => {
        async function loadAppConfig(){
            const result = await AppConfigService.getAppConfig();
            if(result.success){
                setAppConfig(result.data);
                onStripeApiKeyLoaded(result.data.stripeApiKey)
            } else {
                onStripeApiKeyLoaded(appConfig.stripeApiKey)
            }
        } 
        if(!isOffline) {
            loadAppConfig()
        } else {
            onStripeApiKeyLoaded(appConfig.stripeApiKey)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOffline])

    const onStripeApiKeyLoaded = (stripeApiKey: string) => {
		const windowAny: any = window;
		if (windowAny.Stripe) {
			console.log("Stripe loaded");
			const stripe: stripe.Stripe = windowAny.Stripe(stripeApiKey);
			setStripe(stripe);
		} else {
			console.log("Stripe hasn't finished loading");
			window.document!.querySelector("#stripe-js")!.addEventListener("load", () => {
				console.log("Stripe loaded");
				// Create Stripe instance once Stripe.js loads
				const stripe: stripe.Stripe = windowAny.Stripe(stripeApiKey);
				setStripe(stripe);
			});
		}
	};

    const onChangeTitle = (newTitle: string) => {
		if (newTitle === title) {
			return;
		}
		document.title = newTitle;
		setTitle(newTitle);
	};

    if(stripe === null){
        return <LoadingPage />;
    }

    return (
        <AppConfigContext.Provider value={[appConfig, setAppConfig]}>
            <PageTitleContext.Provider value={[title, onChangeTitle]}>
                <StripeProvider stripe={stripe}>
                    {props.children}
                </StripeProvider>
            </PageTitleContext.Provider>
        </AppConfigContext.Provider>
    );
}